export default "/images/vendor/flag-icon-css/flags/4x3/im.svg?1471ac6032ffd876694380eb656d1146";